import AtomsText from "../atoms/AtomsText"
import Swal from 'sweetalert2'

const MoleculesAppsBox = (props) => {
    const openApp = (url) => {
        if(url){
            Swal.fire({
                title: 'Loading...',
                text: 'Let me prepare the site first😁',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading()
                }
            })
              
            setTimeout(() => {
                Swal.close()
                window.open(url, '_blank')
            }, 3000)
        } else {
            Swal.fire({ 
                icon: "error", 
                title: "Opps!...", 
                html: `This app is still in Leo's local dev phase 🥲🙏. Come back soon and see what's new!`,
                confirmButtonText: "Ahhh I see"
            })
        }
    }

    return (
        <div className="container btn-apps-main" onClick={(e) => openApp(props.url)}>
            <div className="row">
                <div className="col-md-6">
                    <AtomsText type='main-title' text={props.name}/>
                    <AtomsText type='subtitle-second' text={props.desc}/>
                </div>
                <div className="col-md-6">
                    <div className="img-holder-start">
                        <img className="img img-fluid" src={props.src_logo} alt={props.src_logo}></img>
                    </div>
                    <div className="img-holder-end">
                        <img className="img img-fluid" src={props.src_bg} alt={props.src_bg}/>
                    </div>
                </div>
            </div>
        </div>
    )
}
  
export default MoleculesAppsBox
